export const GENERIC_AUTHENTICATION_WARNING = 'Something went wrong. Please try again or contact support.';

interface AuthenticationWarningOptions {
  ssoError?: string;
  invalidLogin: boolean;
}

export const getAuthenticationWarning = ({
  ssoError,
  invalidLogin,
}: AuthenticationWarningOptions): string | undefined => {
  if (ssoError) {
    return ssoError;
  }

  return invalidLogin ? GENERIC_AUTHENTICATION_WARNING : undefined;
};
